import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        copyOrderDetail: JSON.parse(localStorage.getItem('orderDetail')) || '' 
    },
    mutations: {
        clearOrderDetail(state){
            state.copyOrderDetail = ''
            localStorage.removeItem('orderDetail')
        },
        setCopyOrder(state, data){
            state.copyOrderDetail = data
            localStorage.setItem('orderDetail', JSON.stringify(data))
        },
    }
})
 export default store
